export default __webpack_public_path__ + "static/media/signIn.8484b019.svg";